import { useState, useEffect, useRef } from 'react';

import { MAX_MOBILE_WIDTH } from '~utils/common.utils';

const useWidthSetter = setWindowInfo => {
  const [localWidth, setLocalWidth] = useState(window.innerWidth);
  const widthRef = useRef(localWidth);
  widthRef.current = localWidth;

  const updateWindowWidth = () => {
    const oldWidth = widthRef.current; // Local state has previous data
    const newWidth = window.innerWidth;

    // Only update state if we actually make a transition to a different view
    // Feel free to make this unconditional if a precise pixel width is needed
    // The performance hit shouldn't be a big deal
    if (
      // Desktop to mobile
      (oldWidth > MAX_MOBILE_WIDTH && newWidth <= MAX_MOBILE_WIDTH) ||
      // Mobile to desktop
      (oldWidth <= MAX_MOBILE_WIDTH && newWidth > MAX_MOBILE_WIDTH)
    ) {
      // Update local state
      setLocalWidth(newWidth);

      // Copy it to global state as well
      setWindowInfo(newWidth);
    }
  };

  useEffect(() => {
    setWindowInfo(localWidth);

    // Determine window size in this component and update it to Redux
    window.addEventListener('resize', updateWindowWidth);

    return () => {
      window.removeEventListener('resize', updateWindowWidth);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return true;
};

export default useWidthSetter;
